"use strict";
export function handleMouseUpByBlurring({ currentTarget }) {
  currentTarget.blur();
}
